export default function ncFormatNumber(num: number) {
    // CAN LAM THEM PHAN DATE FOrMAT ---- get_option(date_format)
    if (!num) return "";
  
    let number = new Intl.NumberFormat("fa-IR").format(num);

    return number;
  }
  